import type { ColumnDef, Row } from '@tanstack/react-table';
import { Checkbox } from '@src/design-system/checkbox';
import TiclickTableRowActions, {
  type RowActionItemsProps,
} from './ticlick-table-row-actions';

const selectColumn = <T,>(): ColumnDef<T> => ({
  id: 'select',
  header: ({ table }) => (
    <Checkbox
      checked={
        table.getIsAllPageRowsSelected() ||
        (table.getIsSomePageRowsSelected() && 'indeterminate')
      }
      onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
      aria-label='Select all'
    />
  ),
  cell: ({ row }) => (
    <Checkbox
      className='p-0'
      checked={row.getIsSelected()}
      onCheckedChange={(value) => row.toggleSelected(!!value)}
      aria-label='Select row'
    />
  ),
  size: 40,

  enableSorting: false,
  enableHiding: false,
  enablePinning: false,
  enableResizing: false,
});

/** `selectable: false` drops the checkbox column, for tables without bulk
 * actions. */
const generateColumnsWithDefaultColumns = <T,>(
  columns: ColumnDef<T>[],
  rowActions: RowActionItemsProps<T>[],
  { selectable = true }: { selectable?: boolean } = {}
): ColumnDef<T>[] => [
  ...(selectable ? [selectColumn<T>()] : []),
  ...columns,

  ...(rowActions && rowActions.length > 0
    ? [
        {
          id: 'actions',
          header: 'Actions',
          cell: ({ row }: { row: Row<T> }) => (
            <TiclickTableRowActions
              row={row}
              actions={rowActions}
            />
          ),
          enableHiding: true,
          enablePinning: true,
          enableResizing: false,
        },
      ]
    : []),
];

export default generateColumnsWithDefaultColumns;
